<template>
  <fb-form-properties-manager :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "PatientAllergiesV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "textInput",
          properties: {
            label: "Description"
          },
          property: "description"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
